const _jsxFileName = "C:\\Users\\MartinStein\\Documents\\Development\\open.CHECK\\open.CHECKLIST\\src\\js\\custom_wehn\\AuftragspositionComponent.js"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import { Button, List, Result } from "antd";
import produce from "immer";
import Parse from "parse";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router";
import { useSearchParams } from "react-router-dom";
import Loading from "../components/Loading";
import { getListItem, getLagerOrteMap } from "./common";
import { $wehn } from "./state";
import { Artikel } from "./types-generated";

export default function AuftragspositionComponent(props) {
  if (props.ShowNextButton()) {
    props.ShowNextButton(false);
  }

  const navigate = useNavigate();
  const params = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [ref, setRef] = useState(searchParams.get("reference"));
  const [state, setState] = React.useState({
    position: undefined,
  });

  // console.log("AuftragspositionComponent params", params);
  // console.log("AuftragspositionComponent searchParams", searchParams);
  // console.log("AuftragspositionComponent props", props);
  // console.log("AuftragspositionComponent state", state);

  const selectItem = (item) => {
    //O-Teil
    if (!item.artikel) return;

    //Position gesperrt
    if (item.gesperrt) return;

    // navigate(`/entnahme/Auftragsposition/${item.objectId}`);

    $wehn.buchung.openDrawer({
      type: "Auftragsposition",
      id: item.objectId,
    });
  };
  const [lagerOrte, setLagerOrte] = React.useState({});
  const getLagerOrt = async () => {
    const artikel = state.position
      .map((pos) => _optionalChain([pos, 'access', _ => _.artikel, 'optionalAccess', _2 => _2.objectId]))
      .filter(Boolean)
      .map((artikelId) => Artikel.createWithoutData(artikelId));

    const result = await getLagerOrteMap(artikel);

    setLagerOrte(result);
  };
  React.useEffect(() => {
    if (_optionalChain([state, 'access', _3 => _3.position, 'optionalAccess', _4 => _4.length]) || 0 > 0) {
      getLagerOrt();
    }
  }, [state.position]);

  const subscribe = async () => {
    const auftrag = await new Parse.Query("Auftrag")
      .equalTo("sqlRef", ref)
      .first();
    const livequery = new Parse.Query("Auftragsposition")
      .equalTo("auftrag", auftrag)
      .containedIn("dispoArt", ["K", "E"]);
    let subscription = await livequery.subscribe();
    const liveUdpate = (object) => {
      fetchAuftragsposition();
    };
    subscription.on("update", liveUdpate);
    subscription.on("create", liveUdpate);
  };
  React.useEffect(() => {
    fetchAuftragsposition();
    subscribe();
  }, [ref]);

  async function fetchAuftragsposition() {
    try {
      const auftrag = await new Parse.Query("Auftrag")
        .equalTo("sqlRef", ref)
        .first();

      const auftragspositionen1 = new Parse.Query("Auftragsposition")
        .equalTo("auftrag", auftrag)
        .containedIn("dispoArt", ["K", "E"])
        .include("auftrag")
        .greaterThan("mengeBereitgestellt", 0)
        .include("artikel");
      const auftragspositionen2 = new Parse.Query("Auftragsposition")
        .equalTo("auftrag", auftrag)
        .containedIn("dispoArt", ["K", "E"])
        .include("auftrag")
        .greaterThan("mengeAngefordert", 0)
        .include("artikel");
      const auftragspositionen = await new Parse.Query.or(
        auftragspositionen1,
        auftragspositionen2
      ).find();

      if (!auftragspositionen) {
        throw new Error("Position not found");
      }
      const positionen = await Promise.all(
        auftragspositionen.map(async (auftragsposition) => {
          const removals = await new Parse.Query("open_transaction_artikel")
            .equalTo("auftragposition", auftragsposition)
            .equalTo("successful", true)
            .include("user")
            .descending("updatedAt")
            .include("artikel")
            .find();

          let cPos = auftragsposition.toJSON();
          cPos.removals = removals.map((parseObject) => parseObject.toJSON());
          if (cPos.artikel) {
            let artikelnr = auftragsposition
              .get("artikel")
              .get("artikelnummer");
            if (cPos.artikel.__type === "Pointer") {
              const artikelToFetch = await new Parse.Object("Artikel", {
                id: cPos.artikel.objectId,
              }).fetch();
              artikelnr = artikelToFetch.get("artikelnummer");
            }

            cPos.artikelnr = artikelnr;
          }

          return cPos;
        })
      );

      setState(
        produce((draft) => {
          draft.position = positionen;

          delete draft.error;
        })
      );
    } catch (error) {
      console.error("StockRemovalPosition: Could not retrieve Position", error);

      setState(
        produce((draft) => {
          delete draft.position;
          draft.error = {
            status: "warning",
            title: "Positionen konnten nicht gefunden werden",
          };
        })
      );
    }
  }

  const sortItems = (item1, item2) => {
    const doneFlag1 =
      item1.fertig &&
      !(
        (item1.mengeAngefordertNichtBestellt > 0 ||
          item1.mengeBestelltWehn > 0) &&
        item1.mengeIst == 0 &&
        item1.mengeSoll == 0
      );
    const mailFlag1 =
      item1.mengeAngefordertNichtBestellt > 0 || item1.mengeBestelltWehn > 0;
    const gesperrtFlag1 =
      !(
        item1.mengeAngefordertNichtBestellt > 0 || item1.mengeBestelltWehn > 0
      ) &&
      item1.gesperrt &&
      !item1.fertig;

    const doneFlag2 =
      item2.fertig &&
      !(
        (item2.mengeAngefordertNichtBestellt > 0 ||
          item2.mengeBestelltWehn > 0) &&
        item2.mengeIst == 0 &&
        item2.mengeSoll == 0
      );
    const mailFlag2 =
      item2.mengeAngefordertNichtBestellt > 0 || item2.mengeBestelltWehn > 0;
    const gesperrtFlag2 =
      !(
        item2.mengeAngefordertNichtBestellt > 0 || item2.mengeBestelltWehn > 0
      ) &&
      item2.gesperrt &&
      !item2.fertig;

    const begonnenFlag1 = !item1.fertig && item1.mengeIst > 0;
    const begonnenFlag2 = !item2.fertig && item2.mengeIst > 0;

    const oteilFlag1 = !item1.artikel;
    const oteilFlag2 = !item2.artikel;

    const keinBestandFlag1 =
      !doneFlag1 &&
      !begonnenFlag1 &&
      !_optionalChain([lagerOrte, 'access', _5 => _5[_optionalChain([item1, 'access', _6 => _6.artikel, 'optionalAccess', _7 => _7.objectId])], 'optionalAccess', _8 => _8.lagerNr]);
    const keinBestandFlag2 =
      !doneFlag2 &&
      !begonnenFlag2 &&
      !_optionalChain([lagerOrte, 'access', _9 => _9[_optionalChain([item2, 'access', _10 => _10.artikel, 'optionalAccess', _11 => _11.objectId])], 'optionalAccess', _12 => _12.lagerNr]);

    if (gesperrtFlag1 !== gesperrtFlag2) {
      if (gesperrtFlag1) return 1;
      return -1;
    }
    if (doneFlag1 !== doneFlag2) {
      if (doneFlag1) return 1;
      return -1;
    }
    if (oteilFlag1 !== oteilFlag2) {
      if (oteilFlag1) return 1;
      return -1;
    }
    if (mailFlag1 !== mailFlag2) {
      if (mailFlag1) return 1;
      return -1;
    }
    if (keinBestandFlag1 !== keinBestandFlag2) {
      if (keinBestandFlag1) return 1;
      return -1;
    }
    if (begonnenFlag1 !== begonnenFlag2) {
      if (begonnenFlag1) return 1;
      return -1;
    }

    const lager1 = _optionalChain([lagerOrte, 'access', _13 => _13[_optionalChain([item1, 'optionalAccess', _14 => _14.artikel, 'optionalAccess', _15 => _15.objectId])], 'optionalAccess', _16 => _16.lagerNr]) || 0;
    const lager2 = _optionalChain([lagerOrte, 'access', _17 => _17[_optionalChain([item2, 'optionalAccess', _18 => _18.artikel, 'optionalAccess', _19 => _19.objectId])], 'optionalAccess', _20 => _20.lagerNr]) || 0;
    //TODO if lager1 - lager2 ==0 -> Artikelnr
    return lager1 - lager2;
  };

  if (state.error) {
    return (
      React.createElement(Result, {
        status: state.error.status,
        title: state.error.title,
        extra: 
          React.createElement(Button, {
            type: "primary",
            key: "back",
            onClick: () => {
              navigate("/select");
            }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 245}}
          , "zurück"

          )
        , __self: this, __source: {fileName: _jsxFileName, lineNumber: 241}}
      )
    );
  }

  if (!state.position) {
    return React.createElement(Loading, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 260}} );
  }

  return (
    React.createElement(React.Fragment, null
      , React.createElement(List, {
        style: { background: "#fff", padding: "12px" },
        itemLayout: "vertical",
        dataSource: state.position
          .filter((item) => {
            return (
              JSON.stringify(item)
                .toLowerCase()
                .indexOf((state.filter || "").toLowerCase()) != -1
            );
          })
          .sort(sortItems),
        renderItem: (item) => {
          return getListItem(item, lagerOrte, selectItem);
        }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 265}}
      )
    )
  );
}
